/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Aspect_Ratio_LabelInputs */

const en_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect Ratio`)
};

const fr_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratio d'image`)
};

const de_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenverhältnis`)
};

const it_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporzioni`)
};

const ru_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соотношение сторон`)
};

const es_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relación de aspecto`)
};

const zh_cn2_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长宽比`)
};

const ja_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アスペクト比`)
};

const hi_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आस्पेक्ट अनुपात`)
};

const pt_pt2_new_project_aspect_ratio_label = /** @type {(inputs: New_Project_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporção da tela`)
};

/**
* | output |
* | --- |
* | "Aspect Ratio" |
*
* @param {New_Project_Aspect_Ratio_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_aspect_ratio_label = /** @type {((inputs?: New_Project_Aspect_Ratio_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Aspect_Ratio_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_aspect_ratio_label(inputs)
	if (locale === "de") return de_new_project_aspect_ratio_label(inputs)
	if (locale === "it") return it_new_project_aspect_ratio_label(inputs)
	if (locale === "ru") return ru_new_project_aspect_ratio_label(inputs)
	if (locale === "es") return es_new_project_aspect_ratio_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_aspect_ratio_label(inputs)
	if (locale === "ja") return ja_new_project_aspect_ratio_label(inputs)
	if (locale === "hi") return hi_new_project_aspect_ratio_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_aspect_ratio_label(inputs)
	return en_new_project_aspect_ratio_label(inputs)
});